import HeroSection from '@/sections/home/HeroSection'
import AboutSnippet from '@/sections/home/AboutSnippet'
import ServicesPreview from '@/sections/home/ServicesPreview'
import StatsSection from '@/sections/home/StatsSection'
import WhyChooseUs from '@/sections/home/WhyChooseUs'
import ProjectsShowcase from '@/sections/home/ProjectsShowcase'
import Testimonials from '@/sections/home/Testimonials'
import CTASection from '@/sections/home/CTASection'

export default function Home() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <AboutSnippet />
      <ServicesPreview />
      <StatsSection />
      <WhyChooseUs />
      <ProjectsShowcase />
      <Testimonials />
      <CTASection />
    </div>
  )
}
